/** @file compact: an object without its `undefined` fields, so validated inputs carry only what was given. */

/** A shallow copy of `o` without the keys whose value is `undefined`. */
export function compact<T extends Record<string, unknown>>(o: T): T {
  return Object.fromEntries(Object.entries(o).filter(([, v]) => v !== undefined)) as T;
}
